<template>
  <div id="Home" class="view">
    <transition-group name="blend">
      <div v-if="!skipEmailVerification && (!authUser || !authUser.emailVerified)" :key="-1">
        <p>Vennligst bekreft e-postadressen din først</p>
        <button class="btn btn-yellow" @click="sendEmailVerification">Send på nytt</button>
        <button class="btn d4-confirm" @click="$store.dispatch('user/logout')"> Ok, gjort det (logg inn på nytt)</button>
      </div>
      <div v-else-if="!company || addNewCompany" :key="0">
        <div class="company_title">
          <h3>Legg inn kode</h3>
        </div>
        <p>Du kan få koden fra kontaktpersonen i din bedrift</p>
        <form class="code" v-on:submit.prevent="joinCompany">
          <input type="text" v-model="code" placeholder="Firmakode" name="CompanyCode">
          <button class="submit btn btn-yellow d4-confirm" :disabled="code.length < 6" @click="joinCompany"></button>
        </form>
        <button v-if="addNewCompany" class="btn btn-small btn-yellow" @click="addNewCompany = false">Avbryt</button>
        <transition name="fade">
          <p v-if="error" class="is_error">{{error}}</p>
          <p v-if="success" class="is_success">{{success}}</p>
        </transition>
      </div>
      <div v-else-if="company" :key="1" class="column">
        <div class="row">
          <div v-if="true"
            class="d4dropdown"
            :class="{active: showDropdown}"
            @click="showDropdown = !showDropdown">
            <h4 class="d4dropdown-trigger"
              aria-haspopup="true"
              aria-controls="{ 'd4dropdown-menu'}">
              <span class="name">{{company.name}}</span>
              <span v-if="company.id === user.company.id" class="standard">standard</span>
            </h4>
            <div class="d4dropdown-menu"
              id="d4dropdown-menu"
              role="menu">
              <div v-for="(comp, id) in companies" :key="id">
                <button v-show="id !== company.id"
                  @click="$store.dispatch('user/loadCompany', $db.collection('companies').doc(id))">
                  <span class="name">{{comp}}</span>
                  <span v-if="id === user.company.id" class="standard">standard</span>
                </button>
              </div>
              <button class="cta" @click="addNewCompany = true">Koble til nytt firma</button>
            </div>
          </div>
          <h4 class="d4dropdown" v-else>{{company.name}}</h4>
          <router-link :to="{name: isOwner ? 'company' : 'employee'}" class="btn btn-small btn-link"><i class="d4-settings"></i></router-link>
        </div>

        <template v-if="company.barcode && !company.disabled">
          <Barcode :value="company.barcode" :options="{ lineColor: '#000', displayValue: isOwner }" tag="svg" class="barcode boxed" />
          <img v-if="!secureImage" src="/img/loader.svg" alt="Security Image" class="secureimage" />
          <img v-show="secureImage" :src="company.secureImage || '/img/loader.svg'"
            v-on:load="secureImage = true" alt="Security Image" class="secureimage" />
        </template>
        <template v-else>
          <img src="/img/barcode.svg" width="200" class="barcode" />
          <p v-if="company.disabled">Bedriftskonto er deaktivert. Kontakt .H.C. Thaugland for støtte for å aktivere det</p>
          <p v-else-if="!company.barcode">Du har ikke blitt aktivert innenfor firma enda</p>
          <p v-else></p>
          <button class="refresh" @click="$store.dispatch('user/loadCompany', user.company)">PRØV iGJEN <i class="d4-generate"></i></button>
        </template>
      </div>
    </transition-group>
    <Loader :visible="loading || loadingCompany" />
  </div>
</template>

<script>
import { auth } from '@/fire'
import Barcode from '@/components/Barcode.vue'

export default {
  name: 'Home',
  components: {
    Barcode,
  },
  data () {
    return {
      loading: false,
      showDropdown: false,
      addNewCompany: false,
      secureImage: false,
      code: '',
      error: '',
      success: '',
    }
  },
  computed: {
    skipEmailVerification () {
      return window && window.skipEmailVerification
    },
    isLoggedIn () {
      return this.$store.state.user.isLoggedIn
    },
    company () {
      return this.$store.state.user.company
    },
    authUser () {
      return this.$store.state.user.authUser
    },
    user () {
      return this.$store.state.user.data
    },
    isOwner () {
      return this.isLoggedIn && this.company && this.company.owner && this.company.owner.id === this.isLoggedIn
    },
    loadingCompany () {
      return this.user && this.user.company && !this.company
    },
    companies () {
      return this.user && this.user.companies
    },
  },
  watch: {
    company: 'clear',
  },
  mounted () {
    this.$nextTick(() => {
      if (window && window.codeFromEmail) {
        this.code = window.codeFromEmail
        this.$nextTick(() => {
          this.joinCompany()
        })
      }
    })
  },
  methods: {
    clear () {
      this.code = ''
      this.success = ''
      this.error = ''
    },
    sendEmailVerification () {
      this.loading = true
      auth.currentUser.sendEmailVerification().then(() => {
        this.loading = false
        this.$toasted.show(`Epost sendt til ${auth.currentUser.email}`)
      }, (err) => {
        this.loading = false
        console.error(err)
      })
    },
    joinCompany () {
      if (this.loading) return
      this.success = ''
      this.error = ''
      if (this.code.length >= 6) {
        this.loading = true
        const code = this.code.toUpperCase()

        this.$store.dispatch('user/joinCompany', code).then(() => {
          this.success = 'Du har blitt med i selskapet'
          this.loading = false
          this.addNewCompany = false
        }).catch((error) => {
          console.error(error.message)
          switch (error.message) {
            case 'company-is-locked': this.error = 'Selskapet er ikke tilgjengelig for øyeblikket'
              break
            case 'company-has-no-owner': this.error = 'Selskapet har ikke eier enda'
              break
            case 'verify-email': this.error = 'Vennligst bekreft e-postadressen din først'
              if (auth.currentUser && window.confirm('Send bekreftelsesmeldingen på nytt')) {
                this.sendEmailVerification()
              }
              break
            default: this.error = 'Ugyldige kode'
          }
          this.loading = false
        })
      } else {
        this.error = 'Ugyldige kode'
      }
    },
  },
}
</script>

<style lang="scss">
#Home {
  width: 100%;
  max-height: 100%;
  align-items: center;

  &>span, &>span>div {
    width: 100%;
    max-height: 100%;
    text-align: center;
  }

  .refresh {
    background: var(--yellow);
    border-radius: 8px;
    padding: 8px 16px;

    i {
      vertical-align: middle;
      margin-left: 4px;
    }
  }

  .code {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    padding: 2px 2px 2px 16px;
    width: 100%;
    margin: 4px 0;
    box-shadow: 0 2px 8px var(--dark-faded);

    input {
      flex: 1;
      border: none;
      outline: none;
      border-bottom: 1px solid var(--dark-faded);
      margin-right: 12px;
      font-size: 18px;
      text-transform:uppercase
    }

    button {
      width: 48px;
      height: 48px;
      padding: 0;
      font-size: 24rem;
      margin: 2px;
      line-height: 1;
    }
  }

  .company_link {
    display: inline-block;
    margin: 40px auto 20px;
    background: none;
    border: none;
    border-bottom: 1px solid var(--dark-faded);

    i {
      vertical-align: middle;
    }
  }

  .barcode {
    display: block;
    max-height: 35%;
    margin: 12px auto;

    &.boxed {
      box-shadow: 0 0 2px 1px var(--dark-faded);
    }
  }

  img.secureimage {
    width: 130px;
    height: 130px;
    max-height: 30%;
    object-fit: contain;
    display: block;
    margin: 10px auto;
    border-radius: 8px;
    animation-duration: 1s;
    animation-name: pulse;
    animation-iteration-count: infinite;
    animation-direction: alternate;

    transition: .4s;

    &:hover {
      transform: scale(1.1) rotate(373deg);
    }
  }

  .standard {
    font-size: 10px;
    padding: .2em .4em;
    border: 1px solid #d4d4d4;
    color: #888;
    border-radius: 2px;
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>

